<template>
  <div>
    <v-text-field
      hide-details
      dense
      outlined
      v-model="editDate"
      v-mask="'##/##/####'"
      @change="saveDate()"
      @keydown.enter="saveDate()"
      v-if="edit"
      autofocus
      append-icon="mdi-close"
      @click:append="close()"
    />
    <v-btn text @click="editData(date)" v-if="!edit" class="normal-text">
      {{ initialDate }} <span v-if="!initialDate" class="text-small"><i>Clique para Editar</i></span>
    </v-btn>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { formatStringData } from '@/plugins/generic.js'
import { mask } from 'vue-the-mask'

export default {
  directives: {
    mask,
  },
  props: {
    date: String,
    sendDate: String,
    orderId: Number,
  },
  data: () => ({
    edit: false,
    editDate: null,
    initialDate: null,
  }),
  methods: {
    formatStringData,
    editData(value) {
      this.edit = true
      this.editDate = value
    },
    saveDate() {
      const url = `${baseApiUrl}/order`
      if (!this.editDate || this.editDate.length < 10) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Data inválida',
          button: 'Ok!',
        })
        return false
      }
      const date = new Date(this.formatStringData(this.editDate))
      const orderAuthorizedDate = new Date(this.formatStringData(this.sendDate))

      date.setHours(0, 0, 0, 0)
      orderAuthorizedDate.setHours(0, 0, 0, 0)

      if (date < orderAuthorizedDate) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Data prev. entrega transp não pode ser uma data menor que a data de postagem',
          button: 'Ok!',
        })
        return false
      }
      axios
        .put(url, {
          orderIdHubble: this.orderId,
          orderExpectedDate: this.editDate,
        })
        .then(() => {
          this.loading = false
          this.initialDate = this.editDate
          this.edit = false
          this.$emit('input', this.editDate)
        })
        .catch(showError)
    },
    close() {
      this.editDate = this.initialDate
      this.edit = false
    },
  },
  mounted() {
    this.initialDate = this.date
  },
  watch: {
    orderId() {
      this.initialDate = this.date
    },
  },
}
</script>

<style></style>
